<template>
  <div>
    <loader-dialog :showLoader="loading" message="Carregando documento pré-definido..."/>

    <div v-if="!isEmpty(documentToEdit)">
      <v-layout column>
        <v-toolbar>
          <v-layout align-center>
            <v-layout>
              <v-btn icon @click="">
                <v-icon color="grey darken-2" @click="$router.push(`/configuracao/documentos/lista`)">mdi-arrow-left
                </v-icon>
              </v-btn>
              <v-layout row class="mx-4" align-center>

                <v-layout column>
                  <v-tooltip bottom class="text-truncate" max-width="800">
                    <span slot="activator">{{ documentToEdit.abbreviation }}</span>
                    {{ documentToEdit.abbreviation || 'Sem Sigla' }}
                  </v-tooltip>
                  <span class="body-1 grey--text text--darken-2">{{ documentToEdit.name || 'Sem Nome' }}</span>
                </v-layout>

                <edit-attributes-document-type-dialog :documentType="documentToEdit" @save="onSaveEditButton($event)"/>

                <save-document-type-dialog :html="html"/>
              </v-layout>
            </v-layout>

          </v-layout>
        </v-toolbar>
      </v-layout>

      <v-layout class="pt-">
        <editor :init="editorOptions" id="1" :value="html" @input="html = $event"></editor>
        <fields-sidebar @selectField="addField" @changeDocumentFieldValue="changeDocumentFieldValue" :html="html"
                        :creationMode="true"/>
      </v-layout>

    </div>
  </div>
</template>

<script>
import DocumentTypeService from '@/services/system/DocumentTypeService';
import EditAttributesDocumentTypeDialog from "@/components/settings/document_types/EditAttributesDocumentTypeDialog";
import SaveDocumentTypeDialog from "@/components/settings/document_types/SaveDocumentTypeDialog";
import FieldsSidebar from '@/components/document/editor/FieldsSidebar';

import colors from 'vuetify/es5/util/colors';
import {isEmpty} from 'lodash';

import Editor from '@tinymce/tinymce-vue';
import TINYMCE_OPTIONS from '@/constants/TINYMCE_OPTIONS';
import LoaderDialog from "../../../components/LoaderDialog.vue";

export default {
  name: 'DocumentTypeForm',
  components: {
    LoaderDialog,
    EditAttributesDocumentTypeDialog,
    SaveDocumentTypeDialog,
    Editor,
    FieldsSidebar
  },
  data() {
    return {
      loading: true,
      editorOptions: TINYMCE_OPTIONS(),
      text: '',
      html: '',
      isEmpty,
    };
  },
  mounted() {
    this.$store.dispatch('getDocument', this.id);
  },
  async mounted() {
    try {
      this.$store.dispatch('toggleLoader', {show: true});
      const config = await this.fieldsConfig();
      if (this.$route.params.id && this.$route.params.id !== 'novo') {
        const {data} = await DocumentTypeService.show(this.$route.params.id);

        const document = {
          id: data.id,
          name: data.name,
          abbreviation: data.abbreviation,
          content_raw: data.content_raw,
          fields: {
            model_fields: data.fields.model_fields,
            ...config,
          }
        }

        this.$store.dispatch('setDocumentToEdit', document);
      } else {
        const document = {
          id: null,
          name: null,
          abbreviation: null,
          content_raw: '',
          fields: {
            model_fields: [],
            ...config,
          }
        }

        this.$store.dispatch('setDocumentToEdit', document);
      }
    } finally {
      this.$store.dispatch('toggleLoader', {show: false});

      // set loading to false
      this.loading = false;
    }
  },
  computed: {
    documentToEdit() {
      return this.$store.getters.documentToEdit;
    }
  },
  watch: {
    documentToEdit() {
      this.html = this.documentToEdit.content_raw;
      console.log('documentToEdit', this.documentToEdit)
      this.html = this.parseHtml();
    }
  },
  methods: {
    addField(field) {
      // const self = this;
      window.tinymce.activeEditor.execCommand(
        'mceInsertContent',
        false,
        this.fieldNonEditable(field),
      );
    },
    reparseHtml() {
      const html = this.html;
      const reparsed = html.replace(
        /span\s(?:class="mceNonEditable")>(.*)<\/span\>/gm,
        (span) => {
          const [paramName] = span.match(/id="(.*?)"/gm) || [];
          return `#{${paramName.replace(/id=|"/gm, '')}}`;
        },
      );
      return reparsed;
    },
    changeDocumentFieldValue() {
      this.html = this.reparseHtml();
      this.html = this.parseHtml();
    },
    fieldNonEditable(field) {
      return `<span data-field class="mceNonEditable" style="${this.fieldStyle(field)}" id="${field.field_name}">${field.hint || field.alias || field.field_name}</span>`;
    },
    getField(fieldName) {
      const fieldsDocument = [...Object.values(this.documentToEdit.fields)]
      for (let fields of fieldsDocument) {
        if (!fields) {
          continue;
        }

        const value = fields.find(({field_name}) => field_name === fieldName);
        if (value) {
          return value;
        }
      }
    },
    parseHtml() {
      const html = this.html;
      // const params = html.match(/#{[a-záàâãéèêíïóôõöúçñ_ ]+}/gim);
      console.log('parsing')
      return html.replace(/#{[a-záàâãéèêíïóôõöúçñ_ ]+}/gim, (param) => {
        console.log('parsing param')
        const [paramName] = param.match(/[a-záàâãéèêíïóôõöúçñ_ ]+/gim);
        const field = this.getField(paramName);
        console.log(field)
        if (field === undefined) {
          return param;
        }
        return this.fieldNonEditable(field);
      });
    },
    fieldStyle(field) {
      console.log(field)
      if (field && field.required) {
        return `background: ${colors.red.lighten4}; line-height: 1.5; border-radius: 5px; padding: 3px; margin-right: 2px;`;
      } else if (field && field.required === undefined) {
        return `background: ${colors.yellow.lighten4}; line-height: 1.5; border-radius: 5px; padding: 3px; margin-right: 2px;`;
      }
      return `background: ${colors.green.lighten4}; line-height: 1.5; border-radius: 5px; padding: 3px; margin-right: 2px;`;
    },
    async fieldsConfig() {
      const {data: config} = await DocumentTypeService.config();
      return config;
    },
    onSaveEditButton({name, abbreviation}) {
      this.documentToEdit.name = name;
      this.documentToEdit.abbreviation = abbreviation;
    },
  },
};
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/views/settings/document_types/DocumentTypeForm.vue